export enum CodeStepButtonsCancellation {
  datiCancellazione = 'datiCancellazione',
  elencoSoggetti = 'elencoSoggetti',
  altriDati = 'altriDati',
}
